var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _text, _text2, _text3, _text4, _text5, _text6, _text7, _g, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _text8, _rect36, _text9, _rect37, _text10, _rect38, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 540",
    fill: "none",
    role: "img",
    "aria-label": "Social media content calendar dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smaCalBg",
    x1: 0,
    y1: 0,
    x2: 880,
    y2: 540,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a1628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smaCalAccent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a00a8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 540,
    rx: 16,
    fill: "url(#smaCalBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 200,
    height: 500,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 120,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 64,
    width: 80,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 96,
    width: 168,
    height: 120,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.06
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 112,
    width: 72,
    height: 8,
    rx: 3,
    fill: "#9e00ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 132,
    width: 140,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 146,
    width: 120,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.18
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 170,
    width: 56,
    height: 24,
    rx: 6,
    fill: "url(#smaCalAccent)",
    fillOpacity: 0.55
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 170,
    width: 56,
    height: 24,
    rx: 6,
    fill: "#25D366",
    fillOpacity: 0.35
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 232,
    width: 168,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 252,
    width: 140,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.15
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 268,
    width: 100,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.12
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 20,
    width: 620,
    height: 500,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.04
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 40,
    width: 200,
    height: 12,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 64,
    width: 140,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 44,
    width: 72,
    height: 28,
    rx: 8,
    fill: "url(#smaCalAccent)",
    fillOpacity: 0.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 96,
    width: 580,
    height: 36,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.05
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Mon")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Tue")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Wed")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Thu")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Fri")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Sat")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 118,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Sun")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748,
    y: 140,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748,
    y: 224,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748,
    y: 308,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 156,
    width: 64,
    height: 52,
    rx: 6,
    fill: "#E1306C",
    fillOpacity: 0.85
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 164,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 176,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.55
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 188,
    width: 28,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 156,
    width: 64,
    height: 52,
    rx: 6,
    fill: "#1877F2",
    fillOpacity: 0.9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 164,
    width: 40,
    height: 5,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.9
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 176,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.55
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 188,
    width: 32,
    height: 10,
    rx: 4,
    fill: "#25D366",
    fillOpacity: 0.55
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 240,
    width: 64,
    height: 52,
    rx: 6,
    fill: "#0A66C2",
    fillOpacity: 0.9
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 678,
    y: 248,
    width: 44,
    height: 5,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.9
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 678,
    y: 260,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.55
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 678,
    y: 272,
    width: 36,
    height: 10,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.55
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 324,
    width: 64,
    height: 52,
    rx: 6,
    fill: "#000",
    fillOpacity: 0.85
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 332,
    width: 40,
    height: 5,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.9
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 344,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.55
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 356,
    width: 30,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.25
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 248,
    width: 52,
    height: 18,
    rx: 6,
    fill: "#fff",
    fillOpacity: 0.12
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 261,
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#fff",
    fillOpacity: 0.65
  }, "Draft")), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 168,
    width: 52,
    height: 18,
    rx: 6,
    fill: "#25D366",
    fillOpacity: 0.25
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 181,
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#7dffb0"
  }, "Published")), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 252,
    width: 58,
    height: 18,
    rx: 6,
    fill: "url(#smaCalAccent)",
    fillOpacity: 0.35
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 682,
    y: 265,
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#f0c8ff"
  }, "Scheduled")), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 404,
    width: 580,
    height: 96,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.04,
    stroke: "#fff",
    strokeOpacity: 0.08,
    strokeDasharray: "6 4"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 456,
    fontFamily: "system-ui,sans-serif",
    fontSize: 12,
    fill: "#fff",
    fillOpacity: 0.45
  }, "Drag posts here to reschedule")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCalendar);
export default __webpack_public_path__ + "static/media/content-calendar.35641152ef42a88e6122c1b655d652c5.svg";
export { ForwardRef as ReactComponent };